<div class="px-7 pt-8 pb-4">
    <div class="close-modal mr-n4 mt-n7" (click)="activeModal.close()">
        <app-icon [type]="'ThinCross'"></app-icon>
    </div>
    <h3 class="modal-title">{{ title }}</h3>
</div>
